import { render } from "./IButton.vue?vue&type=template&id=fd5b418a"
import script from "./IButton.vue?vue&type=script&lang=js"
export * from "./IButton.vue?vue&type=script&lang=js"

import "./IButton.vue?vue&type=style&index=0&id=fd5b418a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__